// 保单录入/编辑 扩展信息 + 代理信息 字段配置(对齐 .NET release Add.cshtml,数据驱动渲染)
// 字段名与后端 @JsonProperty PascalCase 对齐,直接 v-model 绑定:
//   extInfoFields / agentPiccFields -> insData.InsExtInfo(保存时 stringify 为 ExtInfo)
//   coefInfoFields                 -> insData.InsCoefficientConfig(保存时 stringify 为 CoefficientConfig)
//   saleInfoFields                 -> insData.InsSaleInfo(嵌套对象直传)
// 说明:.NET 中这些字段多为 code==value 的下拉(如 LoanCar 0未知/1是/2否),v3 一律退化为文本输入,
//   文本可安全往返数字/字符串值(与既有 costRateyzt 等 3 字段一致);下拉值映射待后续按字典还原。

export const extInfoFields = [
  { field: 'IsFirstYear', label: '是否首年' },
  { field: 'IsImportedCars', label: '是否进口车' },
  { field: 'operatorCode', label: '操作员代码' },
  { field: 'operatorName', label: '操作员名称' },
  { field: 'companyCode', label: '归属部门代码' },
  { field: 'companyName', label: '归属机构名称' },
  { field: 'editType', label: '编辑类型' },
  { field: 'bizType', label: '业务类型代码' },
  { field: 'agentCode', label: '渠道代码' },
  { field: 'agentName', label: '渠道名称' },
  { field: 'CateGory', label: '业务品质' },
  { field: 'Marking', label: '综合评分' },
  { field: 'Score', label: '评分' },
  { field: 'ctsScore', label: '泰山分' },
  { field: 'SumClaimsAmount', label: '上年累计赔款金额' },
  { field: 'InsUsedPrice', label: '出险最高金额' },
  { field: 'CustomerType', label: '客户类型' },
  { field: 'LossRatio', label: '赔付率' },
  { field: 'AutonomyRatio', label: '自主综合系数' },
  { field: 'PlatformCoefficient', label: '平台交互系数' },
  { field: 'VehicleClaimType', label: '商业险分类' },
  { field: 'LoanCar', label: '分期(贷款)车' },
  { field: 'EarlyInsureDay', label: '提前续保天数' },
  { field: 'ProjectCode', label: '项目代码' },
  { field: 'LastProducerType', label: '续保类型' },
  { field: 'BusinessNature', label: '业务性质' },
  { field: 'IsRepairChannel', label: '是否修理渠道' },
  { field: 'DocumentaryRate', label: '跟单手续费比例' },
  { field: 'VehicleTaxonomy', label: '车系分类' },
  { field: 'VehicleEnergyType', label: '车辆能源类型' },
  { field: 'BusinessTypeLabel', label: '业务类型标签' },
  { field: 'EcompensationRateLabel', label: '预期赔付率标签' },
  { field: 'FValue', label: 'F值' },
  { field: 'AuditOpinion', label: '审核意见' },
  { field: 'BusinessCategory', label: '销售费用分类代码' },
  { field: 'ChargeNumber', label: '业务分类代码' },
  { field: 'ContinuedNoClaimYear', label: '连续未出险年限' },
  { field: 'RiskGrade1', label: '风险等级1(实际)' },
  { field: 'RiskGrade2', label: '风险等级2(实际)' },
  { field: 'CardPayTime', label: '刷卡缴费时间' },
  { field: 'DMUCode', label: '决策单元代码' },
  { field: 'GBBusinessType', label: '光博业务分类' },
  { field: 'SingleCI', label: '单保交强' },
  { field: 'MultipleCI', label: '交商共保类型' },
  { field: 'ProcessingFeeRate', label: '手续费比例' },
  { field: 'InsCostFloatCI', label: '交强费用浮动' },
  { field: 'IsOneCarOnePrice', label: '是否一车一价' },
  { field: 'CFeeMrk', label: '套餐类型' },
  { field: 'LastYearInsuranceNo', label: '上年保单号' },
  { field: 'InsuredHabits', label: '投保习惯' },
  { field: 'EPolicyPaperNo', label: '电子保单流水号' },
  { field: 'ThirdAndDamageSpreading', label: '三者+车损分档' },
  { field: 'NationalDrivingScore', label: '驾驶行为全国评分' },
  { field: 'ProvinceDrivingScore', label: '驾驶行为本省评分' },
  { field: 'CarTeamCode', label: '车队代码' },
  { field: 'LossRatioBusinessClassName', label: '赔付率业务类型' },
  { field: 'GuVehicleTypeScoreValue', label: '七炅风险评分' },
  { field: 'PlatformDes', label: '平台项目代码' },
  { field: 'ComLossCondition', label: '合并出险次数' },
  { field: 'CompleteGrade', label: '整单风险等级' },
  { field: 'FinalClassCi', label: '最终分类（交）' },
  { field: 'FinalClassBi', label: '最终分类（商）' },
  { field: 'BusinessGroup', label: '业务分组' },
  { field: 'IsRegisterApp', label: '是否注册APP' },
  { field: 'PersonPremium', label: '人车联动保费' },
  { field: 'LeagueNumber', label: '团单号' },
  { field: 'customerScore', label: '客户评分' },
  { field: 'CIFixSpcs', label: '交强特别约定' },
  { field: 'BIFixSpcs', label: '商业特别约定' },
  { field: 'DiscountScheme', label: '折扣方案' },
  { field: 'NewVehicleEnergy', label: '是否为新能源' },
  { field: 'CIndexValue', label: 'C指数' },
  { field: 'RBRating', label: '评判等级' },
  { field: 'BusinessCode', label: '业务代码' },
  { field: 'CHDGrade', label: '车慧达三者+车损分档' },
  { field: 'CIForecastGrade', label: '交强险分档预测' },
  { field: 'AgricultureSign', label: '涉农标志' },
  { field: 'BIForecastScore', label: '商业险预测评分' },
  { field: 'CIForecastScore', label: '交强险预测评分' },
  { field: 'SelectFloatLevel', label: '选择浮动档' },
  { field: 'BrandGrade', label: '品牌风险等级' },
  { field: 'BIUltimateLossRatio', label: '商业终极赔付率' },
  { field: 'GBBusinessScore', label: '光博车险承保分' },
  { field: 'TMIndexFee', label: '天马指数(标费)' },
  { field: 'TMIndexFeeUnderwrite', label: '天马指数(核保)' },
  { field: 'UseProduct', label: '使用产品' },
  { field: 'BusinessTypeScore', label: '业务类型评分' },
  { field: 'RegistrationAddress', label: '行驶证地址' },
  { field: 'BIHonourEnjoyPoints', label: '商业险尊享分' },
  { field: 'LastYearInsEndTime', label: '上年保险止期' },
  { field: 'MemberCard', label: '会员卡' },
  { field: 'IsSplitIns', label: '是否拆单' },
  { field: 'InsCourseUsedCount', label: '连续承保期间出险次数' },
  { field: 'OnlineCarLevel', label: '网约车分级' },
  { field: 'ProvinceName', label: '投保地省' },
  { field: 'CJOintFlg', label: '联合投保' },
  { field: 'KmScore', label: '公里保评分' },
  { field: 'IssureAndSignTime', label: '发证日期到出单日期时间(年)' },
  { field: 'QuotesCode', label: '报价风险等级' },
  { field: 'AsynRelation', label: '异步关联' },
  { field: 'CarNetworkGrade', label: '家用车车联网分档' },
  { field: 'PrivateCarGrade', label: '私家车分档' },
  { field: 'InsRemark', label: '保司备注' },
  { field: 'PartitionCode', label: '分区' },
  { field: 'insurancePolicyNo', label: '非车保单' },
  { field: 'Operator', label: '操作员' },
  { field: 'VehicleGrade', label: '车系风险等级' },
  { field: 'BIAllEnjoyPoints', label: '商业险众享分' },
  { field: 'CIAllEnjoyPoints', label: '交强险众享分' },
  { field: 'APIScore', label: '亚太分' },
  { field: 'LastYearAgentCode', label: '上年渠道代码' },
  { field: 'uniteScore', label: '联合评分' },
  { field: 'InsRenewalRating', label: '续保评级' },
  { field: 'UseYearCount', label: '实际使用年数' },
  { field: 'ZLScore', label: '中路分' },
  { field: 'TransferVehicle', label: '过户车辆标识' },
  { field: 'FeeInfoRate', label: '费用信息比例' },
  { field: 'TPICCScore', label: '太平分' },
  { field: 'InsInsuredCount', label: '连续承保年数' },
  { field: 'AnShengScore', label: '安盛是否带出评分' },
  { field: 'ZhongmeiScore', label: '中煤分' },
  { field: 'ZLScoreLevel', label: '中路分评级' },
  { field: 'BlanketInsuranceCode', label: '统保代码' },
  { field: 'BICIEnjoyPoints', label: '交商合计众享分' },
  { field: 'BICINCDEcompensationRate', label: '交商合计含NCD标准保费预期赔付率' },
  { field: 'CIFee', label: '交强险手续费' },
  { field: 'VehicleTaxonomyName', label: '车系名称' },
  { field: 'VehicleTaxonomyClass', label: '车系类别' },
  { field: 'renewalVehicle', label: '续保车辆' },
  { field: 'HBICScore', label: '恒邦分' },
  { field: 'VehicleGrading', label: '整车分档' },
  { field: 'ilogMsg', label: '规则信息提示' },
  { field: 'cplxCity', label: '常跑城市' },
  { field: 'notCompensateOptimalFloatMsg', label: '无赔优不浮动原因' },
  { field: 'roadAccidentFloatingRate', label: '理赔浮动原因' },
  { field: 'VehicleRiskScore', label: '鼎然车辆风险评分' },
  { field: 'VehicleBusinessType', label: '业务分类' },
  { field: 'BICITotalNetEcompensationRate', label: '交商合计净保费预期赔付率' },
  { field: 'TruckScore', label: '小货评分' },
  { field: 'VehicleTaxonomyCode', label: '车系代码' },
  { field: 'TKComScore', label: '泰康综合评分' },
  { field: 'BusinessScore', label: '安诚业务分' },
  { field: 'EPOLICYCOSTRATE', label: '签单折扣下预期保单成本率' },
  { field: 'totalPolicyCostRate', label: '交商合计保单成本率' },
  { field: 'QualityBusiness', label: '优质业务' },
  { field: 'InsuranceScore', label: '车险分' },
  { field: 'InsuranceMark', label: '共保交标志' },
  { field: 'YZBusinessTypeScore2', label: '燕赵业务类型2' },
  { field: 'BIRiskScore', label: '燕赵商强险风险评分' },
  { field: 'CIRiskScore', label: '燕赵交强险风险评分' },
  { field: 'JQCBusiCategory', label: '业务类别（交）' },
  { field: 'BINCDEcompensationRate', label: '商业险含NCD标准保费预期赔付率' },
  { field: 'zjxlGrade', label: '中交兴路评分' },
  { field: 'completeControlScore', label: '终极评分' },
  { field: 'YztPriceScore', label: '定价评分' },
  { field: 'appCode', label: '投保人客户代码' },
  { field: 'carCode', label: '车主客户代码' },
  { field: 'insuredCode', label: '被保人客户代码' },
  { field: 'VehicleTypeNew', label: '车型新分类' },
  { field: 'inputById', label: '录单人' },
  { field: 'QuotationForm', label: '报价形式' },
  { field: 'ZCScore', label: '众诚分' },
  { field: 'ZFGradeLevel', label: '珠峰评级' },
  { field: 'ZFAndCHDGrade', label: '珠峰综合评级' },
  { field: 'ywbklx', label: '业务板块类型' },
  { field: 'LossRatioRiskLevel', label: '赔付率风险等级' },
  { field: 'BitTrafficScore', label: '交强险北理新能源评分' },
  { field: 'DRVehicleRiskScore', label: '车辆风险评分（DR）' },
  { field: 'BranchQualityName', label: '分公司车险品质名称' },
  { field: 'VehicleStyle', label: '交管车型类型' },
  { field: 'Underwritinglevel', label: '核保级别' },
  { field: 'homeallScore', label: '家自车动态评分' },
  { field: 'HeavyDutyTruckScore', label: '重载货车车联评分' },
  { field: 'SunshineCustomerScore', label: '阳光客户分' },
  { field: 'YZVehicleBrand', label: '燕赵车辆品牌' },
  { field: 'JlRiskScore', label: '精励风险评分' },
  { field: 'CustomCondition', label: '自定义条件' },
  { field: 'CTCISort', label: '交强险分类' },
  { field: 'IsImportedCars', label: '进口车' },
  { field: 'DBSpecialAgreement', label: '都邦特别约定' },
  { field: 'HZScore', label: '合众分' },
  { field: 'VehicleAlias', label: '车型别名' },
  { field: 'TruckGrading', label: '货车车辆分档' },
  { field: 'BusinessIdentification', label: '业务标识' },
  { field: 'ApplicantRating', label: '投保人评级' },
  { field: 'CarOwnerNation', label: '车主民族' },
  { field: 'ApplicantNation', label: '投保人民族' },
  { field: 'InsuredNation', label: '被保人民族' },
  { field: 'TAVehicleBrand', label: '申能车辆品牌' },
  { field: 'UbiDisGrade', label: '安华农业外部风险评级' },
  { field: 'LastCompanyName', label: '上年承保公司' },
  { field: 'CIFixPriceStatus', label: '定价交强险状态' },
  { field: 'AnShengIsHaveFee', label: '是否有费' },
  { field: 'SecondhandCarFlag', label: '二手车标识' },
  { field: 'DepthPricingLevel', label: '深度定价分档' },
  { field: 'YZVehicleyName', label: '燕赵车系名称' },
  { field: 'EviDynamicrisk', label: '新能源汽车动态评级' },
  { field: 'DynamicFactorLevel', label: '动态因子等级' },
  { field: 'CBaseScore', label: '安诚商业险的精准评分(基础)' },
  { field: 'DrivingRange', label: '续航里程' },
  { field: 'TargetBusiness', label: '目标业务' },
  { field: 'MarginScore', label: '边际成本率' },
  { field: 'costRateyzt', label: '目标保单成本率' },
  { field: 'ZLTruckLevel', label: '中路特殊风险评级' },
  { field: 'ZLHighwayLevel', label: '中路特殊风险评分' },
  { field: 'fleetAgreementNo', label: '车队协议号' },
  { field: 'LexisNexisScore', label: '律商风险评分' },
  { field: 'JTBusinessScore', label: '承保分' },
  { field: 'MarginScoreLevel', label: '家用车风险等级' },
  { field: 'SmallTruckScoreLevel', label: '小货车综合评分等级' },
  { field: 'zjhcScore', label: '中交货车' },
  { field: 'newEnergyDriveGrade', label: '新能源车辆行驶评级' },
  { field: 'GuCarModelVehicleClass', label: '车型种类' },
  { field: 'BusinessKind', label: '折扣业务小类' },
  { field: 'BusinessKindExpense', label: '费用业务小类' },
  { field: 'ultimateScoreClient', label: '客户合计（含随车）终极评分' },
  { field: 'SystemCode', label: '系统代码' },
  { field: 'basePerformance', label: '绩效' },
  { field: 'VehicleClass', label: '车辆类型' },
  { field: 'ultimateScoreBiCi', label: '交商合计终极评分' },
  { field: 'riskPriceScore', label: '整车风险定价评分' },
  { field: 'ncdBaseFeeScoreBiCi', label: '交商合计NCD后基费评分' },
  { field: 'CarCusAge', label: '车主年龄' },
  { field: 'CarScoreGrade', label: '车险分等级' },
  { field: 'carloadTranche', label: '整车预测分档' },
  { field: 'CHDGradeCATH', label: '国泰车慧达档位' },
  { field: 'carloadTrancheHC', label: '货车整车评级' },
  { field: 'businessStatus', label: '货车风险评分' },
  { field: 'FDScore', label: '富德分' },
  { field: 'YZMajorVehicleClass', label: '燕赵车辆大类' },
  { field: 'ZQScoreLevel', label: '风险评级(主全)' },
  { field: 'ReinsuranceApproveSign', label: '符合再保分出' },
  { field: 'driveRisk', label: '驾驶风险分' },
  { field: 'costPartition', label: '成本区间' },
  { field: 'insureScore', label: '保单风险评分' },
  { field: 'renewalClass', label: '续保客户价值分类' },
  { field: 'cCheHuiScore', label: '车慧达评分' },
  { field: 'underwriteScore', label: '车辆核保分' },
  { field: 'hopeRate', label: '期望折扣' },
  { field: 'dimensionCode', label: '维度编码' },
  { field: 'riskCore', label: '风险分' },
  { field: 'JTUBIGrading', label: 'UBI分档' },
  { field: 'customerRiskRating', label: '客户风险评级' },
  { field: 'factorScore', label: '高速风险评分' },
  { field: 'BusinessVhlScore', label: '安诚评级' },
  { field: 'rybLogo', label: '红黄蓝标识' },
  { field: 'crkScore', label: '睿控评分' },
  { field: 'violationRiskLevel', label: '违章风险评级' },
  { field: 'ProvinceDriScore', label: '大货评分' },
  { field: 'isClaim', label: '是否认领' },
  { field: 'issuingType', label: '出单类型' },
  { field: 'OperatorCodeYX', label: '营销工号' },
  { field: 'LastmonopolyName', label: '上年推荐送修码名称' },
  { field: 'CdpClientLevel', label: '客户等级' },
  { field: 'AutoModelNameDvg', label: '行驶证厂牌型号' },
  { field: 'CSingleJQ', label: '单交标志' },
  { field: 'cmccVerifyCode', label: '山东分' },
  { field: 'cmassCarMrk', label: '团车标识' },
  { field: 'jyFuelType', label: '燃料类型' },
  { field: 'jyFuelTypeCode', label: '燃料种类代码' },
  { field: 'NcdExceptPayScore', label: 'NCD预期赔付分' },
  { field: 'ExceptPayScore', label: '预期赔付分' },
  { field: 'carStyle', label: '渤海交强险名称' },
  { field: 'VehicleDtoVehicleGrade', label: '车型级别' },
  { field: 'TransferRiskLevel', label: '过户车评级风险等级' },
  { field: 'XYHGrade', label: '向阳花标识' },
  { field: 'GScoreLevel', label: '风险评级(G)' },
  { field: 'evScore', label: '律商新能源评分' },
  { field: 'claimAdjust', label: '理赔调整系数' },
  { field: 'accidentDesc', label: '理赔调整系数原因' },
  { field: 'groupName', label: '车组名称' },
  { field: 'zyScore', label: '中原分' },
  { field: 'syCommissionAccom', label: '商业跟单点位' },
  { field: 'carSeriesGrade', label: '车系分等级' },
  { field: 'CheHuiDaHighRisk', label: '高风险值' },
  { field: 'billCor', label: '签单折扣下整单两率和' },
  { field: 'Reminder', label: '预核保信息' },
  { field: 'RepeatTipMessage', label: '重复投保信息' },
  { field: 'businesskindCI', label: '交强险折扣小类代码' },
  { field: 'businesskindnameCI', label: '交强险折扣小类描述' },
  { field: 'businesskindexpenseCI', label: '交强险费用小类代码' },
  { field: 'businesskindnameexpenseCI', label: '交强险费用小类描述' },
  { field: 'businesskindBI', label: '商业险折扣小类代码' },
  { field: 'businesskindnameBI', label: '商业险折扣小类描述' },
  { field: 'businesskindexpenseBI', label: '商业险费用小类代码' },
  { field: 'businesskindnameexpenseBI', label: '商业险费用小类描述' },
  { field: 'FcDocumentaryRate', label: '非车销售费用比例' },
  { field: 'dynamicRiskScore', label: '燃油货车评分(Q)' },
  { field: 'newAndRenewalFlagCI', label: '交强险新保续保转保标识' },
  { field: 'newAndRenewalFlagBI', label: '商业险新保续保转保标识' },
  { field: 'newEnergyLevel', label: '新能源评级' },
  { field: 'xaScore', label: '鑫安分' },
  { field: 'lastYearInstitutionName', label: '上年出单机构' },
  { field: 'lastYearChannelSourceName', label: '上年出单渠道' },
  { field: 'TaxNo', label: '完税凭证号' },
  { field: 'syBizName', label: '统一客户类型' },
  { field: 'RelIsForceSingle', label: '是否商业险关联' },
  { field: 'ciCustomerLabel', label: '交强客户标签' },
  { field: 'biCustomerLabel', label: '商业客户标签' },
  { field: 'yizhangtongscore', label: '壹账通评分' },
  { field: 'jqxPingFen', label: '交强险评分' },
  { field: 'mdlCarloadTranche', label: '重载货车风险评级' },
  { field: 'cqpCount', label: '当前报价次数' },
  { field: 'underwritePriceScore', label: '承保定价系数' },
  { field: 'lastYearClaimTimes', label: '上年理赔次数' },
  { field: 'CHDRating', label: '车慧达评级' },
  { field: 'wxsScore', label: '无锡所交通违法评分值' },
  { field: 'vehicleDescription', label: '车型描述' },
  { field: 'ciRenewalYears', label: '交强险连续续保年数' },
  { field: 'biRenewalYears', label: '商业险连续续保年数' },
  { field: 'renewMrk', label: '续保标识' },
  { field: 'jqClaimsAmount', label: '交强险理赔金额' },
  { field: 'billELR', label: '签单折扣预期赔付率' },
  { field: 'AppCusAge', label: '投保人年龄' },
  { field: 'basePerformanceRate', label: '基础绩效率' },
  { field: 'BIAndCIHonourEnjoyPoints', label: '交商荣誉分' },
  { field: 'BIAndCIUltimateLossRatio', label: '交商终极赔付率' },
  { field: 'BIFixSpcsContext', label: '商业特别约定内容' },
  { field: 'BrandModel', label: '品牌车型' },
  { field: 'BrokerageFeeRate', label: '经纪费率' },
  { field: 'BusinessKindName', label: '业务种类名称' },
  { field: 'BusinessKindNameExpense', label: '费用业务种类名称' },
  { field: 'carloadScore', label: '车载评分' },
  { field: 'CarTeamName', label: '车队名称' },
  { field: 'CHDtapPosition', label: '车慧达分档位置' },
  { field: 'ChgOwnerDate', label: '过户日期' },
  { field: 'CIAndThirdScoreLevel', label: '交强三者评分等级' },
  { field: 'CIFixSpcsContext', label: '交强特别约定内容' },
  { field: 'CIHonourEnjoyPoints', label: '交强荣誉分' },
  { field: 'CityName', label: '城市名称' },
  { field: 'CIUltimateLossRatio', label: '交强终极赔付率' },
  { field: 'DamageCHDGrade', label: '车损车慧达等级' },
  { field: 'DistrictName', label: '区县名称' },
  { field: 'InsBeginTime', label: '扩展起保时间' },
  { field: 'InsCostFloatBI', label: '商业费用浮动' },
  { field: 'InsEndTime', label: '扩展到期时间' },
  { field: 'InsuranceNo', label: '扩展保单号' },
  { field: 'InsuredCusAge', label: '被保人年龄' },
  { field: 'JqxFlag', label: '交强险标志' },
  { field: 'MemberName', label: '会员名称' },
  { field: 'NCDRatio', label: 'NCD系数' },
  { field: 'NegotiatedPrice', label: '协商价格' },
  { field: 'NewVehicleClass', label: '新车辆种类' },
  { field: 'NewVehicleClassCode', label: '新车辆种类代码' },
  { field: 'OutInsPersonName', label: '保司出单员名称' },
  { field: 'PlanName', label: '方案名称' },
  { field: 'promoteSalePlanID', label: '营销方案ID' },
  { field: 'SignDate', label: '扩展签单日期' },
  { field: 'SingleCIScoreLevel', label: '单交强评分等级' },
  { field: 'ThirdCHDGrade', label: '三者车慧达等级' },
  { field: 'TotalWeight', label: '总质量' },
  { field: 'ZLScoreGrade', label: '中联评分等级' }
]

export const coefInfoFields = [
  { field: 'underwritingRate', label: '自主核保系数' },
  { field: 'channelRate', label: '自主渠道系数' },
  { field: 'doubleRate', label: '商业双系数' },
  { field: 'ComEcompensationRate', label: '综合赔付率' },
  { field: 'ecompensationRate', label: '预期赔付率' },
  { field: 'syecompensationRate', label: '商业险预期赔付率' },
  { field: 'jqecompensationRate', label: '交强险预期赔付率' },
  { field: 'nonReparationsRatio', label: '无赔款优待系数调整比例' },
  { field: 'nonClaimDiscountRate', label: '无赔款折扣系数' },
  { field: 'DiscountRate', label: '自主折扣系数' },
  { field: 'BICPICScore', label: '商业险太保分' },
  { field: 'CICPICScore', label: '交强险太保分' },
  { field: 'BICITotalCPICScore', label: '交商合计太保分' },
  { field: 'LifeTableScore', label: '生命表打分' },
  { field: 'BIComLifeTableScore', label: '商业合并生命表打分' },
  { field: 'CIComLifeTableScore', label: '交强合并生命表打分' },
  { field: 'PICCScore', label: '人保分' },
  { field: 'PICCScoreInterval', label: '人保分段' },
  { field: 'independentPriceRate', label: '自主定价系数' },
  { field: 'nonClaimDiscountRateLevel', label: '无赔优系数级别' },
  { field: 'mergerCostRate', label: '合并经营成本率' },
  { field: 'trafficTransgressRate', label: '交通违法系数' },
  { field: 'BIComTableFinalScore', label: '商业合并终极评分' },
  { field: 'independentPriceRateFloat', label: '自主定价系数浮动值' },
  { field: 'policyCostRate', label: '商业险直接变动成本率' },
  { field: 'ComEcompensationRate2', label: '签单折扣预期赔付率2' },
  { field: 'changeableFeeRate', label: '总费用率' },
  { field: 'ComCompensationRate3', label: '签单折扣整单预期赔付率' },
  { field: 'expDisCoef', label: '期望折扣系数' },
  { field: 'ExpectedClaimRate', label: '整单预期赔付率' },
  { field: 'ExpectedClaimRate2', label: '整单预期赔付率2' },
  { field: 'PinAnUnderScore', label: '出险核保评分' },
  { field: 'AllJzScore', label: '合并基费评分' },
  { field: 'CustomerGrowValue', label: '客户成长值B' },
  { field: 'CIComTableFinalScore', label: '交强合并终极评分' },
  { field: 'proposalIndependentPriceRate', label: '建议自主定价系数' }
]

export const saleInfoFields = [
  { field: 'MakeComName', label: '出单机构' },
  { field: 'ComCode', label: '归属机构' },
  { field: 'OwnerName', label: '归属人' },
  { field: 'OperatorName', label: '经办人' },
  { field: 'SubProtocolCode', label: '子协议代码' },
  { field: 'ChannelTypeName', label: '渠道类型' },
  { field: 'BusinessNatureName', label: '业务来源' },
  { field: 'DisputeProcessName', label: '争议处理' },
  { field: 'CarCheckerName', label: '验车人' },
  { field: 'MonopolyName', label: '推荐送修点' },
  { field: 'DealTypeName', label: '缴付费类型' },
  { field: 'Batchnumber', label: '报批号' },
  { field: 'BatchName', label: '报批名称' },
  { field: 'ServiceComName', label: '服务机构' },
  { field: 'ServiceUserName', label: '服务机构业务员' },
  { field: 'MonopolyCode', label: '推荐送修码' },
  { field: 'CooperationCode', label: '合作方' },
  { field: 'CustomerSourceCode', label: '客户来源' },
  { field: 'LastYearCompanyCode', label: '上年归属机构' },
  { field: 'NetworkCode', label: '网点编码' },
  { field: 'SalesmanCode', label: '业务员' },
  { field: 'ComDevSalesmanCode', label: '综拓业务员' },
  { field: 'MainBusinessMarkNo', label: '业务识别号' },
  { field: 'ServiceAreaCode', label: '服务区域' },
  { field: 'MaintenancePersonnelCode', label: '维护人员' },
  { field: 'ArbitrationName', label: '仲裁名称' },
  { field: 'ComDevSalesmanName', label: '综拓业务员名称' },
  { field: 'ComName', label: '归属机构名称' },
  { field: 'CooperationName', label: '合作方名称' },
  { field: 'CustomerSourceName', label: '客户来源名称' },
  { field: 'LastYearCompanyName', label: '上年归属机构名称' },
  { field: 'MainBusinessMarkName', label: '业务识别名称' },
  { field: 'MaintenancePersonnelName', label: '维护人员名称' },
  { field: 'SalesmanName', label: '业务员名称' },
  { field: 'ServiceComCode', label: '服务机构代码' }
]

export const agentPiccFields = [
  { field: 'OutInsPersonCode', label: '保司出单员' },
  { field: 'AgentCode', label: '代理渠道代码' },
  { field: 'SpecialChannelCode', label: '特殊渠道代码' },
  { field: 'SpecialChannelName', label: '特殊渠道名称' },
  { field: 'References', label: '推荐人' },
  { field: 'LastOperatorName', label: '上年经办人' },
  { field: 'PiccAssetUserName', label: '互动专员' },
  { field: 'PiccIdentifyNum', label: '对方销售员工号' },
  { field: 'PiccAgentName', label: '对方销售员工名称' },
  { field: 'PiccMakeCom', label: '出单机构代码' },
  { field: 'PiccMakeComDes', label: '出单机构名称' },
  { field: 'lastYearChannelSourceName', label: '上年归属渠道' },
  { field: 'PiccIdentifyNumJX', label: '交叉销售员工代码' },
  { field: 'PiccAgentNameJX', label: '交叉销售员工名称' }
]

// InsuranceInfoEx 嵌套对象(Java DTO 有 insuranceInfoEx 字段,但 save 路径未验证,暂不绑定,仅作参考)
export const insuranceInfoExFields = [
  { field: 'AgentName', label: '代理人' },
  { field: 'InsuranceType', label: '保单类型' }
]



// WEBPACK FOOTER //
// ./src/data/insuranceExt.js